var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircleM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.642 24.324C62.883 22.53 61.953 20.823 60.876 19.227C60.336 18.429 59.76 17.658 59.148 16.917C56.703 13.953 53.7 11.469 50.298 9.621C48.6 8.697 46.8 7.932 44.922 7.35C43.044 6.768 41.085 6.36 39.069 6.156C38.058 6.054 37.035 6 36 6C19.431 6 6 19.431 6 36C6 52.569 19.431 66 36 66C37.035 66 38.058 65.946 39.066 65.844C41.082 65.64 43.041 65.235 44.919 64.65C46.797 64.065 48.597 63.3 50.298 62.379C53.7 60.531 56.703 58.047 59.148 55.083C59.76 54.342 60.336 53.571 60.876 52.773C61.953 51.177 62.883 49.473 63.642 47.676C65.16 44.088 66 40.143 66 36C66 31.857 65.16 27.912 63.642 24.324ZM39 54H33V48H39V54ZM39 42H33V18H39V42Z",
    fill: "#FFA100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleM);
export default __webpack_public_path__ + "static/media/alert-circle-M.91719c425ef3f383b781be4c576377b6.svg";
export { ForwardRef as ReactComponent };